import { render, staticRenderFns } from "./SocioeconomicLevel.vue?vue&type=template&id=676fdb0b&"
import script from "./SocioeconomicLevel.vue?vue&type=script&lang=js&"
export * from "./SocioeconomicLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports